import {configureStore, ReducersMapObject} from '@reduxjs/toolkit'
import env from 'hiya-common/src/reducers/env'
// 转化_reducer的类型使得可以作为configureStore的泛型参数
type ReducerType<S extends ReducersMapObject<any>> = {
  [K in keyof S]: ReturnType<S[K]>
}

// 包装createStore 使得公共reducer 也可进行类型推到
export function initCreateStore<T extends ReducersMapObject<any>>(_reducer: T) {
  const reducer = {
    env,
    ..._reducer,
  }
  return (preloadedState?) =>
    configureStore<ReducerType<typeof reducer>>({
      reducer,
      preloadedState,
    })
}
export const createStore = initCreateStore({})
export type StoreType = ReturnType<typeof createStore>
export type RootState = ReturnType<StoreType['getState']>
